import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DhlFormControl } from '../../models/dhl-form-control';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-form-field-text',
    templateUrl: './form-field-text.component.html',
    styleUrls: ['./form-field-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormFieldTextComponent {
  @Input() configData: DhlFormControl & { text: string, css?: any };
  @Input() frmGroup: UntypedFormGroup;

  constructor(private sanatizer: DomSanitizer) { }

  safeCss(style: string) {
    if (!style) {
      return undefined;
    }

    return this.sanatizer.bypassSecurityTrustStyle(style);
  }
}
